import React, { useEffect, useState } from 'react';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Chart } from "react-chartjs-2";
ChartJS.register(
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 ChartDataLabels
);
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import Drawer from 'components/Drawer';
import DrugTypeAnalysisDrawer from '../GridData/DrugTypeAnalysisDrawer';
import FormularyTierMetricsDrawer from '../GridData/FormularyTierMetricsDrawer';
const FormularyTierMetrics  = ({data,searchData}) => {
    const [isOpen, setIsOpen] = useState(false);
       const [disabledViewButtom, setDisabledViewButtom] = useState(true);
   
   useEffect(() => {
     if (data[0] != null ) {
       setDisabledViewButtom(false);
     } else {
       setDisabledViewButtom(true);
     }
   }, [data]);

       const tierLabels = [];
       const tierData=[]
let data1 = data[0]
for (let i = 1; i <= 20; i++) {
  tierLabels.push(`Tier${i}`);

}
tierLabels.push('Tier97','Tier98','Tier99')
  const chartData = {

    
labels:tierLabels,
datasets:[
      {
        label: 'Spend ($) Per Tier',
        data: [data1?.tier1Spend,data1?.tier2Spend,data1?.tier3Spend,data1?.tier4Spend,data1?.tier5Spend,
          data1?.tier6Spend,data1?.tier7Spend,data1?.tier8Spend,data1?.tier9Spend,data1?.tier10Spend,data1?.tier11Spend,
          data1?.tier12Spend,data1?.tier13Spend,data1?.tier14Spend,data1?.tier15Spend,data1?.tier16Spend,
          data1?.tier17Spend,data1?.tier18Spend,data1?.tier19Spend,data1?.tier20Spend,data1?.tier97Spend,data1?.tier98Spend,data1?.tier99Spend
          

        ],
        backgroundColor: '#B54DA0',
        borderColor: '#B54DA0',
         fill: true,
        yAxisID: 'y1', 
        type: 'bar',
categoryPercentage: 0.6,
barPercentage: 0.8,

    //        datalabels:{
    //     display:true,
    //         anchor:'end',
    //  align:'nearest',
    //          }
      
      },
      {
        label: 'Claim Count Per Tier',
        data: [
          data1?.tier1Count,data1?.tier2Count,data1?.tier3Count,data1?.tier4Count,data1?.tier5Count,
          data1?.tier6Count,data1?.tier7Count,data1?.tier8Count,data1?.tier9Count,data1?.tier10Count,data1?.tier11Count,
          data1?.tier12Count,data1?.tier13Count,data1?.tier14Count,data1?.tier15Count,data1?.tier16Count,
          data1?.tier17Count,data1?.tier18Count,data1?.tier19Count,data1?.tier20Count,data1?.tier97Count,data1?.tier98Count,data1?.tier99Count
        ],
        borderColor: '#383636ff',
        backgroundColor: '#383636ff',
        fill: true,
        yAxisID: 'y2',
        type: 'line', 
             datalabels:{
        display:true,
            anchor:'start',
     align:'end',
             }
      },
      
    ],
  }

  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0
        },
        grid: {
          display: false
        }
      },
      y1: {
        type: 'linear',
        position: 'left',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Spend ($)',
        },
      },
      y2: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Claim Count',
        },
      },
    },
    plugins: {
      title: {
        display: true,
        //text: 'Formulary Tier Metrics: Spend vs Claim Count',
      },
      datalabels: {
        display: false,
      },
       legend: {
       position: 'bottom',
           labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
  };
 
 const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }
    
 return (
    <div >
      <ErrorBoundary >
            <Card className="mb-3">
            <CardBody >
              <CardTitle tag={"h6"}>Formulary Tier Metrics </CardTitle>
              <div style={{ overflowX: 'auto', width: '100%' }}>
  <div style={{ width: `${chartData.labels.length * 80}px`, height: '269px' }}>
    <Bar data={chartData} options={options} />
  </div>
</div>
               <div className="view-report">
                        <Button
                            color='primary'
                            className='ms-2'
                            onClick={handleProceed}
                            style={{ float: "right", marginTop: "26px" }}
                            disabled={disabledViewButtom}
                        >
                            View Report
                        </Button>
                    </div>
            </CardBody>
          </Card>
            <Drawer
                direction='end'
                title='Formulary Tier Metrics'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                <FormularyTierMetricsDrawer searchData={searchData}  onHandleIsOpen={onHandleIsOpen}  />
            </Drawer> 
          </ErrorBoundary>
    </div>
 );
}
export default  FormularyTierMetrics;